export default "__VITE_ASSET__Ds5B$eSc__"